/**
 * Format a numeric value as South African Rand currency
 * @param {number} value - The value to format
 * @param {boolean} includeDecimals - Whether to include decimal places (default: true)
 * @returns {string} Formatted currency string (e.g., "R1,234.56" or "R1,234")
 */
export const formatCurrency = (value, includeDecimals = true) => {
  if (value === undefined || value === null) return 'R0.00'

  // Fix for floating point precision issues
  const roundedValue = includeDecimals ? Math.round(value * 100) / 100 : Math.round(value)

  return `R${
    includeDecimals
      ? roundedValue.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : roundedValue.toLocaleString('en-ZA')
  }`
}

/**
 * Format a number with thousands separators
 * @param {number} value - The value to format
 * @param {number} decimals - Number of decimal places to include (default: 0)
 * @returns {string} Formatted number string (e.g., "1,234.56" or "1,234")
 */
export const formatNumber = (value, decimals = 0) => {
  if (value === undefined || value === null) return '0'

  return value.toLocaleString('en-ZA', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
}

/**
 * Format a percentage value
 * @param {number} value - The value to format (e.g., 0.75 for 75%)
 * @param {number} decimals - Number of decimal places to include (default: 1)
 * @returns {string} Formatted percentage string (e.g., "75.0%")
 */
export const formatPercentage = (value, decimals = 1) => {
  if (value === undefined || value === null) return '0%'

  // Convert decimal to percentage (e.g., 0.75 -> 75)
  const percentage = value < 1 ? value * 100 : value

  return `${percentage.toLocaleString('en-ZA', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })}%`
}
